import React from 'react'
import PropTypes from 'prop-types'
import { isToday, isSameYear, isSameMonth, isSameDay } from 'date-fns'
import { Button, Center, useTheme } from '@chakra-ui/react'
import { useDay } from '@datepicker-react/hooks'

import { useDatePickerCore } from '../../context'

export const Day = ({ date, ...rest }) => {
  const theme = useTheme()

  const dayRef = React.useRef(null)
  const context = useDatePickerCore()
  const { isSelected, isSelectedStartOrEnd, isWithinHoverRange, disabledDate, ...restOfHook } = useDay({ ...context, date, dayRef })

  const isStart = React.useMemo(() => context.isStartDate(date), [date, context])
  const isEnd = React.useMemo(() => context.isEndDate(date), [date, context])
  const isSpecific = context.disabledDates.some((disabled) => isSameYear(disabled, date) && isSameMonth(disabled, date) && isSameDay(disabled, date))

  return (
    <Center
      marginY='0.125rem'
      paddingX='0.25rem'
      bg={
        context.numberOfMonths > 1 && isSelectedStartOrEnd
          ? `linear-gradient(to ${isStart ? 'right' : isEnd && 'left'}, transparent 50%, ${theme.colors.brand[50]} 0)`
          : context.numberOfMonths > 1 && (isSelected || isWithinHoverRange)
          ? 'brand.50'
          : 'transparent'
      }
    >
      <Button
        ref={dayRef}
        variant='unstyled'
        position='relative'
        boxSize='2.25rem'
        minWidth='initial'
        color={isSelectedStartOrEnd ? 'white' : 'inherit'}
        bgColor={isSelectedStartOrEnd ? `${context.colorScheme}.500` : 'transparent'}
        borderWidth='1px'
        borderColor={isToday(date) ? `${context.colorScheme}.500` : 'transparent'}
        borderRadius='full'
        isDisabled={disabledDate}
        _hover={!isSelectedStartOrEnd && { color: 'inherit', bgColor: 'brand.50' }}
        _after={{
          content: '""',
          position: 'absolute',
          left: '50%',
          bottom: '0.1875rem',
          transform: 'translateX(-50%)',
          display: 'block',
          boxSize: '0.25rem',
          bgColor: isSpecific ? `${context.colorScheme}.500` : 'transparent',
          borderRadius: '50%',
        }}
        {...restOfHook}
        {...rest}
      />
    </Center>
  )
}

Day.propTypes = {
  date: PropTypes.instanceOf(Date),
}
